import * as React from 'react';

import { StyledIconButton } from './icon-button.styles';

import { IconButtonProps } from './icon-button.types';

export const IconButton = ({ size = 'medium', ...props }: IconButtonProps): JSX.Element => (
  <StyledIconButton size={size} {...props} />
);
